import React from "react";
import { STRINGS } from "../../../strings";
import { TrainingCenterBundleCourse } from "../../../system/AppState/AppStateTrainingCenter";
import { translate } from "../../../translate";
import { If } from "../../Generic/If";
import { isTrainingCenterCourseCompleted } from "../../TrainingCenter/TrainingCenterUtils";

interface Props {
  course: TrainingCenterBundleCourse;
}

const TrainingCenterBundleCourseStatus = (props: Props) => {
  const isCompleted = isTrainingCenterCourseCompleted(props.course);
  const totalLessons = props.course.bundleItems.length;
  const totalCompleted = props.course.bundleItems.filter((x) => x.itemCompleted).length;

  return (
    <div className="TrainingCenterBundleCourseStatus">
      <If condition={isCompleted} comment="is completed">
        <div className="course-completed">{translate(STRINGS.COMPLETED)}!</div>
      </If>

      <If condition={!isCompleted} comment="is not completed">
        <div className="course-progress">{`${totalCompleted}/${totalLessons}`}</div>
        <div className="lessons-text">{translate(STRINGS.LESSONS)}</div>
      </If>
    </div>
  );
};

export default TrainingCenterBundleCourseStatus;
